import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#000',
    text1: '#FFFFFF',
    text2: '#C3C5CB',
    text3: '#6C7284',
    text4: '#565A69',

    // backgrounds / greys
    bg0: '#191326',
    bg1: '#2b233f',
    bg2: '#2b233f',
    bg3: '#40444F',
    bg4: '#565A69',
    bg5: '#6C7284',

    //specialty colors
    modalBG: 'rgba(0,0,0,.425)',
    advancedBG: 'rgba(0,0,0,0.1)',

    //primary colors
    primary1: '#24c7d6',
    primary4: '#376bad70',
    primary5: '#153d6f70',

    // color text
    primaryText1: '#6da8ff',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#24c7d6'
  }
}
